export const navigationConstants = {
    PUT_CONGRATS: 'PUT_CONGRATS',
    PULL_NEXT_CONGRATS: 'PULL_NEXT_CONGRATS',
    PUT_NEXT_SCREEN_PARAMS: 'PUT_NEXT_SCREEN_PARAMS',
    PULL_NEXT_SCREEN_PARAMS: 'PULL_NEXT_SCREEN_PARAMS'
}